import LocationPicker from '@/components/LocationPicker';
import UserPicker from '@/components/UserPicker';
import useUsersReports from '@/hooks/useUsersReports';
import React from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Input,
  InputGroup,
  InputGroupText,
  Row,
} from 'reactstrap';

const UsersReportFilter = () => {
  const { changeFilter, resetFilters, filters, applyFilters, loading } =
    useUsersReports();

  return (
    <React.Fragment>
      <Card>
        <CardHeader className="card-primary">
          <CardTitle tag="h4">
            <i className="mdi mdi-filter" /> Filtre
          </CardTitle>
        </CardHeader>
        <CardBody>
          <Row>
            <Col md={3}>
              <UserPicker
                onPick={(id: any) => changeFilter('user_id', id)}
                value={filters.user_id}
              />
            </Col>
            <Col md={3}>
              <LocationPicker
                selectedLocation={filters.location_id}
                onPick={(id: any) => changeFilter('location_id', id)}
              />
            </Col>
            <Col md={3}>
              <div className="form-group">
                <label htmlFor="data">De la</label>
                <Input
                  type="date"
                  value={filters.startDate}
                  onChange={(e) => changeFilter('startDate', e.target.value)}
                  className="form-control"
                  id="data"
                />
              </div>
            </Col>
            <Col md={3}>
              <div className="form-group">
                <label htmlFor="end_date">Pana la</label>
                <Input
                  type="date"
                  value={filters.endDate}
                  onChange={(e) => changeFilter('endDate', e.target.value)}
                  className="form-control"
                  id="end_date"
                />
              </div>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md={3}>
              <div className="form-group">
                <label htmlFor="is_business">Firma/PF</label>
                <select
                  className="form-control"
                  id="is_business"
                  value={filters.account_type}
                  onChange={(e) => changeFilter('account_type', e.target.value)}
                >
                  <option value="">Toate</option>
                  <option value="0">Persoana Fizica</option>
                  <option value="1">Persoana Juridica</option>
                </select>
              </div>
            </Col>
            <Col md={3}>
              <div className="form-group">
                <label htmlFor="sex">Sex</label>
                <Input
                  type="select"
                  name="sex"
                  value={filters.sex}
                  onChange={(e) => changeFilter('sex', e.target.value)}
                >
                  <option value="">Toate</option>
                  <option value="feminin">Feminin</option>
                  <option value="masculin">Masculin</option>
                  <option value="nespecificat">Nespecificat</option>
                </Input>
              </div>
            </Col>
            <Col md={3}>
              <div className="form-group">
                <label htmlFor="puncte_min">Minim Puncte</label>
                <InputGroup>
                  <InputGroupText>{'Puncte >='}</InputGroupText>
                  <Input placeholder="Minim de puncte" type="number" />
                </InputGroup>
              </div>
            </Col>
            <Col md={3}>
              <div className="form-group">
                <label htmlFor="puncte_max">Maxim Puncte</label>
                <InputGroup>
                  <InputGroupText>{'Puncte <='}</InputGroupText>
                  <Input
                    onChange={(e) => changeFilter('max_points', e.target.value)}
                    value={filters.max_points}
                    placeholder="Maxim de puncte"
                    type="number"
                  />
                </InputGroup>
              </div>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md={3}>
              <div className="form-group">
                <label htmlFor="min_age">Varsta Minima</label>
                <InputGroup>
                  <InputGroupText>{'<'}</InputGroupText>
                  <Input
                    onChange={(e) => changeFilter('min_age', e.target.value)}
                    value={filters.min_age}
                    placeholder="Varsta Minima"
                    type="number"
                  />
                </InputGroup>
              </div>
            </Col>
            <Col md={3}>
              <div className="form-group">
                <label htmlFor="puncte_max">Varsta Maxima</label>
                <InputGroup>
                  <InputGroupText>{'>'}</InputGroupText>
                  <Input
                    onChange={(e) => changeFilter('max_age', e.target.value)}
                    value={filters.max_age}
                    placeholder="Varsta Maxima"
                    type="number"
                  />
                </InputGroup>
              </div>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col />
            <Col md={2}>
              <Button
                onClick={applyFilters}
                color="primary"
                block
                disabled={loading}
              >
                Aplica Filtre
              </Button>
            </Col>
            <Col md={2}>
              <Button onClick={resetFilters} color="primary" outline block>
                Sterge Filtre
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default UsersReportFilter;
